import { useSnackbarCustom } from 'hooks/useSnackCustom';
import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from 'redux/hooks';
import { ROLES } from 'roles/roles';

interface Props {
    children?: JSX.Element;
    allowedRoles?: Array<string>;
    label?: string;
};

const AccessDenied = ({ label }: { label?: string }) => {
    const { addError } = useSnackbarCustom();
    useEffect(() => {
        addError({
            message: `Usuário sem permissão${label ? ` - ${label}` : ''}`,
            closeable: true,
            id: 'acesso-negado',
            preventDuplicate: true,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <Navigate to="/home" />;
};

const Guard = ({ children, allowedRoles, label }: Props) => {
    const { token } = useAppSelector((state) => state);

    // *** Descomenta pra ter o tokenProvider *** //
    // if (!token.access_token) {
    //     dispatch(setToken(tokenLocal));
    //     dispatch(setEsSelecionado(tokenLocal.ESTABELECIMENTOS[0]));
    // }

    const isAdmin = token.KEY_CLOAK_ROLES.includes(ROLES.ADMIN);
    const isSuper = token.KEY_CLOAK_ROLES.includes(ROLES.SUPER);

    const roleMatches = (userRoles: string[]) =>
        userRoles.some(r =>
            allowedRoles?.some(a => r === a || r.startsWith(a + '#'))
        );

    const containsRole = (isAdmin || isSuper)
        ? true
        : roleMatches(token.NEXUS_ROLES) || roleMatches(token.KEY_CLOAK_ROLES_SUBS);

    if (!token.access_token) {
        return <Navigate to="/login" />;
    }

    if (!containsRole) {
        return <AccessDenied label={label} />;
    }

    return children ? <>{children}</> : <Outlet />;
};

export default Guard;
